/** Offline demo manifest — generated by scripts/build-demo-pack.py */
export const DEMO_MANIFEST_URL = "/demo/manifest.json";

export const REPORT_TABS = [
  { id: "behavioral-analysis-report", label: "Behavioral" },
  { id: "game-report", label: "Game" },
  { id: "genre-benchmark-report", label: "Benchmark" },
  { id: "evidence-workbook", label: "Workbook" },
  { id: "evidence-appendix", label: "Appendix" },
];
